import CategoryItem from 'components/Blocks/Categories/CategorySubcategories/CategoryItem/CategoryItem';
import { twJoin } from 'tailwind-merge';
import { ImageType } from 'types/image';
import { FilterOptionsUrlQueryType } from 'types/productFilter';

export type SubCategoryType = {
    slug: string;
    link: string | null;
    mainImage: ImageType | null;
    name: string;
    productsCount: number;
};

export type CategorySubcategoriesProps = {
    listedItems: SubCategoryType[];
    filter?: FilterOptionsUrlQueryType;
    displayProductCount?: boolean;
    className?: string;
    itemClassName?: string;
};

const CategorySubcategories: FC<CategorySubcategoriesProps> = ({
    listedItems,
    displayProductCount,
    filter,
    className,
    itemClassName,
}) => {
    if (listedItems.length > 0) {
        return (
            <ul className={twJoin('-mx-1 mb-7 flex flex-row flex-wrap p-0 md:-mr-1', className)}>
                {listedItems.map((listedItem, key) => (
                    <CategoryItem
                        key={key}
                        isSubcategory
                        className={itemClassName}
                        displayProductCount={displayProductCount}
                        filter={filter}
                        listedItem={listedItem}
                    />
                ))}
            </ul>
        );
    }

    return null;
};

export default CategorySubcategories;
